export const BUSINESS_CASE_FINANCIAL_PRODUCTS_SUBSCRIPTION_OPTIONS = {
  pollingInterval: 30_000,
  refetchOnFocus: true,
  refetchOnReconnect: true,
} as const;
